import type { AxiosInstance } from "axios";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";

export function dashboardUrl(eventIdPublic: EventIdPublic): string {
  return `/api/v1/events/${encodeURIComponent(EventIdPublic.unwrap(eventIdPublic))}/dashboard`;
}

export function createDashboardApi(apiClient: AxiosInstance) {
  // Returns unknown: the response is validated by the repo hook's schema parse,
  // not here. An axios response generic would be an unchecked cast, not validation.
  async function getEventDashboard(
    eventIdPublic: EventIdPublic,
  ): Promise<unknown> {
    const response = await apiClient.get(dashboardUrl(eventIdPublic));
    return response.data;
  }

  return {
    getEventDashboard,
  } as const;
}
